// extracted by mini-css-extract-plugin
export default {"comfortBuy":"csUOJ","advantagesList":"aKbn6","advantagesItem":"plejo","advantagesPic":"DRNGI","cnImage":"OcUeG","heading":"IehUo","description":"JY8lR","note":"QxRBW"};